module.exports = __webpack_public_path__ + "img/084.c3aab9d6.png";